import styled from "@emotion/styled";

export const Description = styled.p`
    font-size: 16px;
    opacity: 0.7;
    font-weight: normal;
    margin-bottom: 30px;
`;
